module.exports = __webpack_public_path__ + "img/j1.5de31442.jpeg";